export default __webpack_public_path__ + "static/media/truck.a139a78a.png";